<!-- Copyright (c) 2009-2022. Authors: see NOTICE file.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.-->

<!-- Top-bar Chat entry point (M2 — replaces the retired `src/components/chat/ChatEntry.vue`,
     which read the Vuex chat module directly). Host chrome (ADR-0003/OQ-3): unlike LIS, IMS can't
     render an island-exported React component inline in its Vue navbar, so this stays a thin
     native Vue button — the unread count comes from `chatBadgeState.js` (fed by
     `ChatHost.onUnreadChange`, see `buildImsChatHost.js`), and the click commands the mounted
     island via `@zaya-chat/ui-react`'s package-level `toggleDock(el)` (M2, mirrors
     `mount`/`unmount`'s own precedent — see `mount.tsx`'s header comment). -->
<template>
  <button type="button" class="chat-top-bar-entry" :aria-label="$t('chat.title') || 'Chat'" @click="toggle">
    <span v-if="badge.unreadCount > 0" class="chat-top-bar-entry-badge">{{ badge.unreadCount }}</span>
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M21 11.5a8.4 8.4 0 0 1-11.9 7.6L3 21l1.9-6A8.4 8.4 0 1 1 21 11.5z" />
    </svg>
    <span>{{ $t('chat.title') || 'Chat' }}</span>
  </button>
</template>

<script>
import { useChatBadgeState } from './chatBadgeState';
import { getChatMountEl } from './chatMountRef';

export default {
  name: 'chat-top-bar-entry',
  data() {
    return {
      badge: useChatBadgeState(),
    };
  },
  methods: {
    toggle() {
      const el = getChatMountEl();
      if (!el) {
        return;
      }
      import('@zaya-chat/ui-react').then(({ toggleDock }) => toggleDock(el));
    },
  },
};
</script>

<style scoped>
.chat-top-bar-entry {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #2f6df6;
  font-weight: 700;
  font-size: 13.5px;
  background: #eef3ff;
  border: none;
  cursor: pointer;
  padding: 7px 11px;
  border-radius: 9px;
  font-family: inherit;
  position: relative;
}
.chat-top-bar-entry-badge {
  background: #e2466b;
  color: #fff;
  font-size: 10.5px;
  font-weight: 700;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
}
</style>
